export default {
  noBlocks: 'Správa zatiaľ neobsahuje žiadne bloky.',
  addBlock: 'Pridať blok',
  expandAll: 'Rozbaliť všetko',
  collapseAll: 'Zbaliť všetko',
  hint: {
    startsOnNewPage: 'Začína na novej strane',
    templateReplaced: 'Šablóna nahradená',
    parametersOnExport: 'Parametre pri exporte',
    unavailable: 'Už nie je dostupný',
    onlyFor: 'Len pre: {scope}',
  },
};
